<div>
  <mat-form-field class="w-full" subscriptSizing="dynamic">
    <mat-label>Search</mat-label>
    <input
      #searchInput
      matInput
      [formControl]="searchControl"
      [placeholder]="showCnpj ? 'Search by Code, Name, CNPJ, City or State' : 'Search by Code, Name, City or State'"
    />
  </mat-form-field>
  <div class="keyboard-nav-hint">
    <span>&#9660; &#9650; Navigate rows</span>
    <span class="hint-divider">&#183;</span>
    <span><kbd>Enter</kbd> Select</span>
    <span class="hint-divider">&#183;</span>
    <span><kbd>Esc</kbd> Back to search</span>
  </div>
  @if (tableConfig) {
  <mic-table [config]="tableConfig" [fetcher]="fetcher" [uniqueKey]="'customerPk'" class="table-stripped">
    <ng-container *micTableNoData>
      <mic-empty-state icon="layers_clear" title="No customers found."></mic-empty-state>
    </ng-container>
  </mic-table>
  }
</div>
